enum notificationsActionTypes {
  ADD_NOTIFICATION = 'NOTIFICATIONS/ADD_NOTIFICATION',
  CLEAR_NOTIFICATION = 'NOTIFICATIONS/CLEAR_NOTIFICATION',
}

export default notificationsActionTypes;
